import { ICompanySubmitRequest } from '@company/types/company';
import { api } from '@services/api';

const companyRequestApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createCompanyRequest: builder.mutation<ICompanySubmitRequest, ICompanySubmitRequest>({
            query: (event) => ({
                url: 'company/request/new-company/',
                method: 'POST',
                body: {
                    company_name: event.companyName,
                    company_type_id: event.companyType,
                    country_code: event.country,
                    sales_manager_id: event.salesManager,
                },
            }),
            invalidatesTags: ['UserRequests'],
        }),
    }),
});
export const { useCreateCompanyRequestMutation } = companyRequestApi;
export default companyRequestApi;
